const urlPrefix = `/IlocosSur/Legislative/api`;
var vRecID;

const comMemberList = () => {
    return new Promise(resolve => {
        var settings = {
            "url": `${urlPrefix}/leg-track/comMemberList`,
            "method": "POST",
            "data": {},
            "headers": {
                /* "Content-Type": "application/json" */
            }
        };
        $.ajax(settings)
            .always(function(msg) {
                resolve(msg);
            });
    });
}

const comMemberDtl = () => {
    return new Promise(resolve => {
        var settings = {
            "url": `${urlPrefix}/leg-track/comMemberDtl`,
            "method": "POST",
            "data": {
                "recid": vRecID,
            },
            "headers": {
                /* "Content-Type": "application/json" */
            }
        };
        $.ajax(settings)
            .always(function(msg) {
                resolve(msg);
            });
    });
}

const memberOnClick = (e) => {
    _showLoading();
    vRecID = e;
    comMemberDtl().then((data) => {
        if (data.success) {
            $("#sp-img").attr("src", "/IlocosSur/members/" + data.img)
            $("#sp-name-hdr").html(data.name)
            $("#sp-title").html(data.title)
            $("#sp-name").html(data.name)
            $("#sp-position").html(data.position)
            $("#sp-address").html(data.address)
            $("#sp-contact").html(data.contact)
            $("#sp-school").html(data.school)
            $("#sp-achievements").html(data.achievements)
            $("#sp-others").html(data.others)

            $("#spMemberModal").modal('show');
        } else {
            _notif("error", data.message);
        }
        _hideLoading();
    });
}
window.memberOnClick = memberOnClick

$(() => {


    _showLoading();
    comMemberList().then((data) => {
        var img, name, title, position;
        var element = "";
        $.each(data, function(i, record) {
            for (var i in record) {
                title = '<p class="text-decoration-none fs-5 fw-bold text-hdr ls-6 text-secondary text-uppercase mb-0">' + record[i].title + '</p>';
                img = '<div class="col-md-12 col-8 mx-auto text-center h-250-px mb-2"><img onerror="$(this).addClass(`d-none`);$(this).parent(`div`).addClass(`border`)" src="/IlocosSur/members/' + record[i].img + '" class="mw-100" src="" alt="' + record[i].position + '" height="250"></div>';
                name = '<a href="#" class="text-decoration-none fs-5 fw-medium text-hdr ls-6 text-primary member-dtl" onclick="memberOnClick(' + record[i].recid + ')">' + record[i].name + '</a> <br>';
                position = '<span class="text-info">' + record[i].position + '</span>';

                element = element + '<div class="col-lg-3 col-md-4">' + img + title + name + position + '</div>';
            }
        });
        $("#div-row").html(element);
        _hideLoading();
    });




});
